module.exports = __webpack_public_path__ + "files/e8a03454952fb8c9044f12cbbee6040c.png";